import { render, staticRenderFns } from "./TradePreviewSection.vue?vue&type=template&id=7560382a&scoped=true&"
import script from "./TradePreviewSection.vue?vue&type=script&lang=ts&"
export * from "./TradePreviewSection.vue?vue&type=script&lang=ts&"
import style0 from "./TradePreviewSection.vue?vue&type=style&index=0&id=7560382a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7560382a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDivider,VList,VListItem,VListItemContent,VListItemTitle,VProgressCircular,VRow})
